<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "../../app.logic";
  import Input from "../../components/Form/Fields/Input.svelte";
  import CustomFields from "../../components/CustomFields/CustomFields.svelte";
  import Textarea from "../../components/Form/Fields/Textarea.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import type { IProduct } from "../../entities";
  import FormLayout from "../../layout/FormLayout.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import {
    customFieldsSchemas,
    initDetail,
    record,
    save,
  } from "./product.store";

  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit = $record != null && $record.name != "";

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<IProduct> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/product/${u.oid}`);
    } else {
      onCancel();
    }
  }

  function onCancel() {
    navigate(`/product`);
  }

  onMount(() => initDetail(oid));
</script>

<MainLayout>
  {#if $record}
    <div class="columns">
      <div class="column is-9">
        <FormLayout
          {canSubmit}
          {isNew}
          on:submit={onSubmit}
          on:cancel={onCancel}
        >
          <div class="columns">
            <div class="column">
              <FormField>
                <Input
                  name="Nome"
                  placeholder="Nome"
                  required={true}
                  bind:value={$record.name}
                />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <FormField>
                <Textarea
                  name="Note"
                  placeholder="note"
                  required={false}
                  bind:value={$record.notes}
                />
              </FormField>
            </div>
          </div>

          <CustomFields
            schemas={$customFieldsSchemas}
            bind:values={$record.customFields}
          />
        </FormLayout>
      </div>
      <div class="column is-3">
        <!--
        <div class="box">
          <h1 class="subtitle">Riepilogo</h1>
        </div>
      -->
      </div>
    </div>
  {/if}
</MainLayout>
